import React from "react";

interface PaginationProps {
    style: React.CSSProperties;
    className: string;
    Next?: React.ReactType;
    Previous?: React.ReactType;
    PageDropdown?: React.ComponentType;
}

// TODO translate the aria
export const Pagination = ({ PageDropdown, style, className }: PaginationProps) => (
        <div style={style} className={className}>
            <nav aria-label="Page navigation">
                {PageDropdown && <PageDropdown /> }
            </nav>
        </div>
    );
